module.exports = __webpack_public_path__ + "static/img/mine-top-avatar.d97e588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mine-top-avatar.png
// module id = agoZ
// module chunks = 0